/**
 * Customer branding (DEV-182): which logo the login screen shows and the page
 * title. Pure functions, so they are tested without a browser.
 */

import type { Branding, BrandingLogo } from './types';

export const DEFAULT_PAGE_TITLE = 'AssetRadar';

/** "AssetRadar" or "AssetRadar – <suffix>": AssetRadar is never replaced. */
export function pageTitle(suffix: string | null | undefined): string {
  const trimmed = (suffix ?? '').trim();
  return trimmed === '' ? DEFAULT_PAGE_TITLE : `${DEFAULT_PAGE_TITLE} – ${trimmed}`;
}

/** The logo to show and whether it needs a plate in the other theme's colour. */
export interface LogoChoice {
  logo: BrandingLogo;
  /**
   * Set when only the other theme's logo exists: it is shown on a plate in
   * that theme's colour, so a dark logo stays readable on a dark screen.
   */
  plate: 'light' | 'dark' | null;
}

export function chooseLogo(branding: Branding | null, theme: 'light' | 'dark'): LogoChoice | null {
  if (branding === null) return null;
  const own = branding.logos[theme];
  if (own !== null) return { logo: own, plate: null };
  const other = theme === 'dark' ? branding.logos.light : branding.logos.dark;
  return other === null ? null : { logo: other, plate: theme === 'dark' ? 'light' : 'dark' };
}

/** Whether the login screen shows a customer block at all. */
export function hasCustomerBlock(branding: Branding | null): boolean {
  return branding !== null
    && (branding.text.trim() !== '' || branding.logos.light !== null || branding.logos.dark !== null);
}
